import React from 'react'
import Sliders from '../components/home/Sliders'
import Application from '../components/home/Application'
import Stats from '../components/home/Stats'
import WhyChose from '../components/home/WhyChose'
import Partners from '../components/home/Partners'

const HomePage = () => {

    return(<>
        <Sliders />
        <Application />
        <Stats />
        <WhyChose />
        <Partners />
    </>
    )

}

export default HomePage
